import { normalizeDescendants } from './utilities.mjs';
import { deserializeHTMLNode } from './deserializeHTMLNode.mjs';

/**
 * Deserialize HTML element.
 */
const deserializeHTMLElement = ({
  plugins,
  element
}) => {
  return normalizeDescendants(deserializeHTMLNode(plugins)(element));
};

export { deserializeHTMLElement };
